import { render, staticRenderFns } from "./MenuDesktop.vue?vue&type=template&id=dd1b0a42&scoped=true&"
import script from "./MenuDesktop.vue?vue&type=script&lang=ts&"
export * from "./MenuDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./MenuDesktop.vue?vue&type=style&index=0&id=dd1b0a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1b0a42",
  null
  
)

export default component.exports